class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.is('.layout-4');

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.getVariantData();
        this.updateVariantStatuses();
        this.updateOptions();
        this.updateMasterId();
        if (this.currentVariant && this.currentVariant.id) {
            updateVariantGallery(this.currentVariant.id);
            updateVariantDescription(this.currentVariant.id);
            updateVariantDimensions(this.currentVariant.id);
            updateVariantDiscount(this.currentVariant.id);
        }
        this.updateMedia(1500);
        // this.updateURL();
        this.renderProductAjaxInfo();
        this.renderProductInfo();
        if (!this.currentVariant) {
            this.updateAttribute(true);
        } else {
            this.updateAttribute(false, !this.currentVariant.available);
        }
    }
    
    onVariantChange(event) {
        this.updateVariantStatuses();
        this.updateOptions();
        this.updateMasterId();
        this.updatePickupAvailability();
      
        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            updateVariantGallery(this.currentVariant.id);
            this.updateMedia(200);
            if (!document.querySelector('.featured-product')) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            updateVariantDescription(this.currentVariant.id);
            updateVariantDimensions(this.currentVariant.id);
            updateVariantDiscount(this.currentVariant.id);
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }
  
    decodeOption(option) {
      if (option) {
          return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
          return null
        }
    }

    encodeOption(option) {
        if (option) {
          return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
          return null
        }
    }
    
    updateMasterId() {
        this.decodeOptions()
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });
    }      

    updateMedia(time) {
        if (!this.currentVariant) return;
        const mediaId = this.currentVariant?.featured_media?.id || this.currentVariant?.featured_image?.id;
        if (!mediaId) return;

        window.setTimeout(() => {
            const targetMediaEl = document.querySelector(
                `[data-media-id="${mediaId}"], [data-target-id="${mediaId}"], [data-media-id*="${mediaId}"]`
            );

            if (targetMediaEl) {
                const slickSlide = $(targetMediaEl).closest('.slick-slide');
                let slideIndex = slickSlide.length ? slickSlide.data('slick-index') : undefined;

                if (typeof slideIndex === 'undefined' || slideIndex === null) {
                    const dataIdx = targetMediaEl.closest('[data-index]')?.getAttribute('data-index') || targetMediaEl.getAttribute('data-index');
                    if (dataIdx) slideIndex = parseInt(dataIdx, 10) - 1;
                }

                if (typeof slideIndex !== 'undefined' && slideIndex !== null && slideIndex >= 0) {
                    $('.productView-nav, .productView-for').each(function() {
                        if ($(this).hasClass('slick-initialized')) {
                            $(this).slick('slickGoTo', slideIndex);
                        }
                    });
                }

                const clickTarget = targetMediaEl.querySelector('.productView-thumbnail-link') || targetMediaEl;
                if (typeof $(clickTarget).trigger === 'function') {
                    $(clickTarget).trigger('click');
                }
            }
        }, time || 100);
    }

    filterMediaByColor() {
        // Disabled to prevent breaking slick slider thumbnails
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height 
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height 
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight 

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                if(destinationProperty) {
                    if (sourceProperty) {
                        destinationProperty.innerHTML = sourceProperty.innerHTML;
                        destinationProperty.style.display = 'table';
                    } else{
                        destinationProperty.style.display = 'none';
                    }
                } else if (sourceProperty) {
                    document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
                if (this.currentVariant && this.currentVariant.id) {
                    updateVariantGallery(this.currentVariant.id);
                    updateVariantDiscount(this.currentVariant.id);
                    updateVariantDescription(this.currentVariant.id);
                    updateVariantDimensions(this.currentVariant.id);
                }
        });
    }

    renderProductInfo() {
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inventoryQuantity = parseInt(inven_num);

                this.item.find('input[name="quantity"]').attr('data-inventory-quantity', inventoryQuantity);

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
        });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }
        
        if(unavailable){
            var text = window.variantStrings.unavailable;

            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            addButton.setAttribute('disabled', true);
            addButton.textContent = text;
            quantityInput.closest('quantity-input').addClass('disabled');

            if(hotStock.length > 0) hotStock.addClass('is-hiden');
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val();

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val();
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val();

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                addButton.removeAttribute('disabled');
                addButton.textContent = text;
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val();
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){
        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const itemImage = sticky.find('.sticky-image');
            const option = sticky.find('.select__select');
            const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
            const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
            var quantityInput = this.item.find('input[name="quantity"]');
            var maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
          
            if(unavailable){
                var text = window.variantStrings.unavailable;

                button.setAttribute('disabled', true);
                button.textContent = text;
            } else {
                if (!this.currentVariant) return;

                const image = this.currentVariant?.featured_image;
                
                if (image != null) {
                    itemImage.find('img').attr({
                        'src': image.src,
                        'srcset': image.src,
                        'alt': image.alt
                    });
                }

                option.val(this.currentVariant.id);

                if (disable) {
                    var text = window.variantStrings.soldOut;

                    button.setAttribute('disabled', true);
                    button.textContent = text;
                } else {
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }

                    button.removeAttribute('disabled');
                    button.textContent = text;
                }

                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    getVariantData() {
        if (!this.variantData) {
            const jsonEl = this.querySelector('script[data-product-json], script[data-product-variants], script[type="application/json"]');
            if (jsonEl) {
                try {
                    const parsed = JSON.parse(jsonEl.textContent);
                    this.variantData = Array.isArray(parsed) ? parsed : (parsed.variants || []);
                    this.productData = Array.isArray(parsed) ? null : parsed;
                } catch(e) {
                    console.error('[VariantPicker] Error parsing variant JSON:', e);
                    this.variantData = [];
                }
            } else {
                this.variantData = [];
            }
        }
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details')?.querySelector('input.quantity__input') || document.querySelector('.productView-details input.quantity__input');
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue 

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1 
      
        if (quantityInput) {
          quantityInput.value = value
        }
      
        const addBtn = document.getElementById('product-add-to-cart');
        if (addBtn && this.currentVariant) {
            addBtn.dataset.available = this.currentVariant.available && maxValue <= 0;
        }
    }

    updateVariantStatuses() {
        const variants = this.getVariantData();
        if (!variants || !variants.length) return;

        const isRadios = this.tagName.toLowerCase() === 'variant-radios';
        const fieldsets = isRadios 
            ? Array.from(this.querySelectorAll('fieldset.product-form__input, fieldset'))
            : Array.from(this.querySelectorAll('.product-form__input--dropdown, .product-form__input'));

        if (!fieldsets.length) return;

        const hasAnyAvailableVariant = variants.some(v => v.available);

        // Step 1: Read currently active/selected values from each option group
        let currentSelections = fieldsets.map((fieldset) => {
            if (isRadios) {
                const checkedRadio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
                    (radio) => radio.checked && !radio.classList.contains('swatch-hidden') && !radio.disabled
                ) || fieldset.querySelector('input[type="radio"]:checked') || fieldset.querySelector('input[type="radio"]');
                return checkedRadio ? this.decodeOption(checkedRadio.value) : null;
            } else {
                const select = fieldset.querySelector('select');
                return select ? this.decodeOption(select.value) : null;
            }
        });

        // Step 2: Cascading visibility check & auto-selection per option group
        fieldsets.forEach((fieldset, groupIndex) => {
            const inputsOrOptions = isRadios
                ? Array.from(fieldset.querySelectorAll('input[type="radio"]'))
                : Array.from(fieldset.querySelectorAll('option'));

            let availableFoundForCurrentSelection = false;
            let firstAvailableItem = null;

            inputsOrOptions.forEach(item => {
                const itemVal = this.decodeOption(item.value);

                // Check if this option value exists in product.variants and has available: true
                // given parent selections (0 ... groupIndex - 1)
                let isAvailable = true;
                if (hasAnyAvailableVariant) {
                    isAvailable = variants.some(variant => {
                        if (!variant.available) return false;
                        for (let p = 0; p < groupIndex; p++) {
                            const parentSel = currentSelections[p];
                            const variantParentVal = variant.options ? variant.options[p] : variant[`option${p + 1}`];
                            if (parentSel && variantParentVal !== parentSel) {
                                return false;
                            }
                        }
                        const variantThisVal = variant.options ? variant.options[groupIndex] : variant[`option${groupIndex + 1}`];
                        return variantThisVal === itemVal;
                    });
                }

                // Toggle visibility on the swatch element / input / label / option
                if (isRadios) {
                    const label = fieldset.querySelector(`label[for="${item.id}"]`) || item.nextElementSibling;
                    if (isAvailable) {
                        item.classList.remove('swatch-hidden', 'soldout');
                        item.removeAttribute('disabled');
                        item.style.display = '';
                        if (label) {
                            label.classList.remove('swatch-hidden', 'soldout', 'unavailable');
                            label.classList.add('available');
                            label.style.display = '';
                        }
                        if (!firstAvailableItem) firstAvailableItem = item;
                        if (item.checked) availableFoundForCurrentSelection = true;
                    } else {
                        item.classList.add('swatch-hidden');
                        item.setAttribute('disabled', 'disabled');
                        item.style.display = 'none';
                        if (label) {
                            label.classList.add('swatch-hidden');
                            label.classList.remove('available');
                            label.classList.remove('soldout');
                            label.style.display = 'none';
                        }
                    }
                } else {
                    if (isAvailable) {
                        item.classList.remove('swatch-hidden', 'soldout');
                        item.hidden = false;
                        item.disabled = false;
                        item.style.display = '';
                        if (!firstAvailableItem) firstAvailableItem = item;
                        if (item.selected) availableFoundForCurrentSelection = true;
                    } else {
                        item.classList.add('swatch-hidden');
                        item.hidden = true;
                        item.disabled = true;
                        item.style.display = 'none';
                    }
                }
            });

            // Step 3: If currently selected option in this group is now hidden/unavailable, auto-select first available option
            if (!availableFoundForCurrentSelection && firstAvailableItem) {
                if (isRadios) {
                    inputsOrOptions.forEach(inp => { inp.checked = false; });
                    firstAvailableItem.checked = true;
                    currentSelections[groupIndex] = this.decodeOption(firstAvailableItem.value);
                } else {
                    const select = fieldset.querySelector('select');
                    if (select) {
                        select.value = firstAvailableItem.value;
                        currentSelections[groupIndex] = this.decodeOption(firstAvailableItem.value);
                    }
                }
            }

            // Step 4: Update header label text for the selected value
            const headerOption = fieldset.querySelector('[data-header-option], .selected-value');
            if (headerOption && currentSelections[groupIndex]) {
                headerOption.innerText = currentSelections[groupIndex];
            }
        });
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        // Maintained for backward compatibility
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.classList.remove('soldout', 'swatch-hidden');
                input.innerText = input.getAttribute('value');
            } else {
                input.classList.add('swatch-hidden');
            }
        });
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }

    updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset.product-form__input, fieldset'));
        this.options = fieldsets.map((fieldset) => {
            const radios = Array.from(fieldset.querySelectorAll('input[type="radio"]'));
            const checkedRadio = radios.find((radio) => radio.checked && !radio.classList.contains('swatch-hidden') && !radio.disabled)
                || radios.find((radio) => radio.checked)
                || radios.find((radio) => !radio.classList.contains('swatch-hidden') && !radio.disabled)
                || fieldset.querySelector('input[type="radio"]');
            return checkedRadio ? checkedRadio.value : '';
        });
    }
}

customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault(); 
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart').dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }
        
        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];
          
            if(itemStatus == 'deny') {
              inputValue = maxValue
              this.input.value = inputValue;
              const message = getInputMessage(maxValue)
              showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if(window.subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            var parser = new DOMParser();

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal') 
            moneySpan.innerText = subTotal 
            document.body.appendChild(moneySpan) 

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText 
            $(moneySpan).remove()

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                pdView_subTotal.textContent = subTotal;
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);

                addButton.textContent = text;  
            }

            const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
            const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

            if (stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if (stickyComparePrice.length && window.subtotal.show) {
                let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
                comparePrice = inputValue * comparePrice;
                comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                comparePrice = extractContent(comparePrice);
                stickyComparePrice.text(comparePrice);
            }
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            mainQty.value = inputValue;

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const button = event.currentTarget || event.target.closest('button');
        const previousValue = this.input.value;
        const buttonName = button ? (button.name || (button.classList.contains('plus') ? 'plus' : 'minus')) : '';
        
        if (buttonName === 'plus') {
            this.input.stepUp();
        } else {
            this.input.stepDown();
        }
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
    }
    
    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }
        
    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart')
        this.input.disabled = addBtn.disabled 
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            if (hotStockText) hotStockText.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
}
const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
    const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
    hotStock(inventoryQuantity);
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}

function getCurrentlySelectedVariantId() {
    // 1. From active custom element instance
    const variantEl = document.querySelector('variant-radios, variant-selects');
    if (variantEl && variantEl.currentVariant && variantEl.currentVariant.id) {
        return variantEl.currentVariant.id;
    }
    // 2. By inspecting all checked option inputs against product.variants JSON
    if (variantEl) {
        let variantData = null;
        if (typeof variantEl.getVariantData === 'function') {
            try { variantData = variantEl.getVariantData(); } catch(e) {}
        }
        if (!variantData) {
            const scriptTag = variantEl.querySelector('script[type="application/json"]');
            if (scriptTag) {
                try { variantData = JSON.parse(scriptTag.textContent); } catch(e) {}
            }
        }
        if (variantData && Array.isArray(variantData)) {
            const fieldsets = Array.from(variantEl.querySelectorAll('fieldset, .product-form__input'));
            const currentSelectedOptions = fieldsets.map(fs => {
                const checked = fs.querySelector('input:checked, option:checked, select');
                return checked ? checked.value : null;
            }).filter(Boolean);
            if (currentSelectedOptions.length) {
                const match = variantData.find(v => {
                    return !v.options.map((opt, idx) => currentSelectedOptions[idx] === opt).includes(false);
                });
                if (match) return match.id;
            }
        }
    }
    // 3. From main form input
    const idInput = document.querySelector('input[name="id"]:not([disabled]), select[name="id"]:not([disabled]), input[name="id"], select[name="id"]');
    if (idInput && idInput.value && !isNaN(Number(idInput.value))) {
        return idInput.value;
    }
    // 4. From URL query param
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariant = urlParams.get('variant');
    if (urlVariant && !isNaN(Number(urlVariant))) {
        return urlVariant;
    }
    return null;
}

function findVariantGallery(variantId, galleryMap) {
    if (!galleryMap) return null;
    const vIdStr = String(variantId);
    
    // 1. If this variant has custom gallery images, return them
    if (galleryMap[vIdStr] && Array.isArray(galleryMap[vIdStr]) && galleryMap[vIdStr].length > 0) {
        return { gallery: galleryMap[vIdStr], key: vIdStr, isCustom: true };
    }
    if (galleryMap[variantId] && Array.isArray(galleryMap[variantId]) && galleryMap[variantId].length > 0) {
        return { gallery: galleryMap[variantId], key: String(variantId), isCustom: true };
    }
    
    // 2. Otherwise, fall back to general default images for variants without custom gallery
    if (galleryMap['default'] && Array.isArray(galleryMap['default']) && galleryMap['default'].length > 0) {
        return { gallery: galleryMap['default'], key: 'default', isCustom: false };
    }
    
    return null;
}

function updateVariantGallery(variantId) {
    if (!variantId) {
        variantId = getCurrentlySelectedVariantId();
    }
    if (!variantId) return;

    const galleryScript = document.querySelector('.tt-variant-galleries');
    if (!galleryScript) return;

    let galleryMap = null;
    try {
        galleryMap = JSON.parse(galleryScript.textContent);
    } catch(e) {
        console.error('Error parsing variant galleries map:', e);
        return;
    }
    if (!galleryMap) return;

    const result = findVariantGallery(variantId, galleryMap);
    if (!result || !result.gallery || result.gallery.length === 0) return;

    const targetGallery = result.gallery;
    const targetGalleryKey = result.key;
    const isCustom = result.isCustom;

    console.log('[VariantGallery] Swapping to variant ID:', variantId, '| activeKey:', targetGalleryKey, '| isCustomMetafield:', isCustom, '| count:', targetGallery.length);

    const mainNav = document.querySelector('.productView-nav');
    if (!mainNav) return;

    const thumbFor = document.querySelector('.productView-for:not(.mobile)');
    const thumbForMb = document.querySelector('.productView-for.mobile');
    const imagesWrapper = document.querySelector('.productView-images-wrapper');
    const productView = document.querySelector('.productView');

    const activeGalleryKey = mainNav.getAttribute('data-active-variant-gallery') || imagesWrapper?.getAttribute('data-active-variant-gallery');

    // If already showing this variant's gallery and slick is initialized, skip DOM rebuild
    if (activeGalleryKey === targetGalleryKey && window.jQuery && $(mainNav).hasClass('slick-initialized')) {
        return;
    }

    // 1. Safely Unslick existing carousels
    if (window.jQuery) {
        if ($(mainNav).hasClass('slick-initialized')) {
            $(mainNav).slick('unslick');
        }
        if (thumbFor && $(thumbFor).hasClass('slick-initialized')) {
            $(thumbFor).slick('unslick');
        }
        if (thumbForMb && $(thumbForMb).hasClass('slick-initialized')) {
            $(thumbForMb).slick('unslick');
        }
    }

    // 2. Read layout settings & attributes
    const mediaSize = mainNav.getAttribute('data-media-size') || 'adapt';
    const mediaFit = mainNav.getAttribute('data-media-fit') || 'contain';
    const portraitRatio = mainNav.getAttribute('data-portrait-aspect-ratio') || '148';
    const zoomedImage = mainNav.getAttribute('data-zoomed-image') === 'true' || mainNav.getAttribute('data-zoomed-image') === '';
    const imagePopup = mainNav.getAttribute('data-image-popup') || 'fancybox';
    const customCursor = mainNav.getAttribute('data-custom-cursor') === 'true';
    const maxThumbs = parseInt(thumbFor?.getAttribute('data-max-thumbnail-to-show') || '5', 10);
    const thumbLayout = thumbFor?.getAttribute('data-thumbnail-layout') || '3';
    const arrowsDesk = mainNav.getAttribute('data-arrows-desk') !== 'false';
    const arrowsMobi = mainNav.getAttribute('data-arrows-mobi') === 'true';

    // 3. Build main gallery slide HTML
    let mainNavHtml = '';
    targetGallery.forEach((item, index) => {
        const idx = index + 1;
        let paddingBottom = '100%';
        if (mediaSize === 'adapt' && item.aspect_ratio) {
            paddingBottom = (1 / item.aspect_ratio * 100).toFixed(2) + '%';
        } else if (mediaSize === 'portrait' && portraitRatio) {
            paddingBottom = portraitRatio + '%';
        } else if (mediaSize === 'square') {
            paddingBottom = '100%';
        }
        const styleAttr = mediaFit !== 'unset' ? `style="padding-bottom: ${paddingBottom};"` : '';
        const zoomAttr = (zoomedImage && !customCursor) ? `data-zoom-image="${item.src}"` : '';
        const fancyboxAttr = (imagePopup === 'fancybox') ? `data-fancybox="images" href="${item.src}"` : '';
        const altText = (item.alt || '').replace(/"/g, '&quot;');
        const altAttr = (item.alt || '').toLowerCase().trim();

        mainNavHtml += `
            <div class="productView-image productView-image-${mediaSize} fit-${mediaFit}" data-index="${idx}" data-media-id="${item.id}" data-media-alt="${altAttr}">
                <div class="productView-img-container product-single__media" data-media-id="${item.id}" ${styleAttr}>
                    <div class="media" ${zoomAttr} ${fancyboxAttr}>
                        <img id="product-featured-image-${item.id}"
                            srcset="${item.src}"
                            src="${item.src}"
                            alt="${altText}"
                            sizes="(min-width: 2000px) 1500px, (min-width: 1200px) 1200px, (min-width: 768px) calc((100vw - 30px) / 2), calc(100vw - 20px)"
                            width="${item.width || 1200}"
                            height="${item.height || 1200}"
                            loading="lazy"
                            data-sizes="auto"
                            data-main-image
                            data-index="${idx}"
                            data-cursor-image
                        />
                    </div>
                </div>
            </div>
        `;
    });
    mainNav.innerHTML = mainNavHtml;

    // 4. Build thumbnail slides HTML
    if (thumbFor || thumbForMb) {
        let thumbHtml = '';
        targetGallery.forEach((item, index) => {
            const idx = index + 1;
            const thumbSrc = (thumbLayout === '3') ? (item.large_src || item.src) : (item.medium_src || item.large_src || item.src);
            const altText = (item.alt || '').replace(/"/g, '&quot;');
            const altAttr = (item.alt || '').toLowerCase().trim();
            thumbHtml += `
                <div class="productView-thumbnail" data-media-id="template--${item.id}" data-target-id="${item.id}" data-media-alt="${altAttr}">
                    <a class="productView-thumbnail-link" href="javascript:void(0)" data-image="${item.large_src || item.src}">
                        <img src="${thumbSrc}" alt="${altText}" title="${altText}" loading="lazy" />
                    </a>
                </div>
            `;
        });
        if (thumbFor) thumbFor.innerHTML = thumbHtml;
        if (thumbForMb) thumbForMb.innerHTML = thumbHtml;
    }

    // 5. Update tracking & counters
    mainNav.setAttribute('data-active-variant-gallery', targetGalleryKey);
    mainNav.setAttribute('data-media-count', targetGallery.length);
    if (imagesWrapper) {
        imagesWrapper.setAttribute('data-active-variant-gallery', targetGalleryKey);
    }
    const countEl = document.querySelector('#count-image');
    if (countEl) countEl.textContent = '1';
    const counterTotalEl = document.querySelector('.slick-counter--total');
    if (counterTotalEl) counterTotalEl.textContent = targetGallery.length;
    const cursorCounterEl = document.querySelector('.cursor-wrapper .counter');
    if (cursorCounterEl) {
        cursorCounterEl.innerHTML = `<span id="count-image">1</span>${targetGallery.length}`;
    }

    // 6. Re-init slick
    if (window.jQuery) {
        const $mainNav = $(mainNav);
        const $thumbFor = thumbFor ? $(thumbFor) : null;
        const isLayout1Or2 = productView ? ($(productView).hasClass('layout-1') || $(productView).hasClass('layout-2')) : true;

        $mainNav.slick({
            fade: true,
            dots: false,
            arrows: arrowsDesk,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: thumbFor ? thumbFor : false,
            nextArrow: window.arrows?.icon_next || '<button type="button" class="slick-next">Next</button>',
            prevArrow: window.arrows?.icon_prev || '<button type="button" class="slick-prev">Prev</button>',
            rtl: window.rtl_slick || false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: arrowsMobi
                    }
                }
            ]
        });

        if ($thumbFor && $thumbFor.length) {
            $thumbFor.slick({
                slidesToShow: maxThumbs,
                slidesToScroll: 1,
                asNavFor: mainNav,
                arrows: true,
                dots: false,
                draggable: false,
                adaptiveHeight: false,
                focusOnSelect: true,
                vertical: isLayout1Or2,
                verticalSwiping: isLayout1Or2,
                infinite: targetGallery.length > maxThumbs,
                nextArrow: window.arrows?.icon_next || '<button type="button" class="slick-next">Next</button>',
                prevArrow: window.arrows?.icon_prev || '<button type="button" class="slick-prev">Prev</button>',
                responsive: [
                    {
                        breakpoint: 1600,
                        settings: {
                            slidesToShow: maxThumbs > 3 ? maxThumbs - 1 : maxThumbs,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 1280,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            rtl: window.rtl_slick || false
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            vertical: false,
                            verticalSwiping: false,
                            rtl: window.rtl_slick || false
                        }
                    }
                ]
            });

            if (isLayout1Or2 && window.innerWidth > 1279) {
                setTimeout(() => {
                    const h = $thumbFor.outerHeight();
                    const m = ($mainNav.outerHeight() - h) / 2;
                    const w = m + 80;
                    if ($thumbFor.find('.slick-arrow').length > 0) {
                        $thumbFor.parent().addClass('arrows-visible').removeClass('arrows-disable').css('top', m);
                    } else {
                        $thumbFor.parent().addClass('arrows-disable').removeClass('arrows-visible').css('top', w);
                    }
                }, 100);
            }
        }

        // 7. Zoom & Fancybox rebind
        if (window.innerWidth > 1024) {
            $mainNav.find('[data-zoom-image]').each(function() {
                $(this).zoom({
                    url: $(this).attr('data-zoom-image'),
                    touch: false
                });
            });
        }

        const fancyboxEls = $mainNav.find('[data-fancybox]');
        if (fancyboxEls.length && typeof fancyboxEls.fancybox === 'function') {
            fancyboxEls.fancybox({
                buttons: ["zoom", "share", "slideShow", "fullScreen", "thumbs", "close"],
                loop: true,
                thumbs: {
                    autoStart: true
                }
            });
        }
    }
}

function updateVariantDescription(variantId) {
    if (!variantId) {
        const idInput = document.querySelector('input[name="id"], select[name="id"]');
        if (idInput) variantId = idInput.value;
    }
    if (!variantId) return;

    const vMapScript = document.querySelector('.tt-variant-descriptions');
    let vDesc = null;
    if (vMapScript) {
        try {
            const vMap = JSON.parse(vMapScript.textContent);
            vDesc = vMap[variantId];
        } catch(e) {
            console.error('Error parsing variant descriptions map:', e);
        }
    }

    // Clean rich text / JSON AST if present
    function formatDescription(desc) {
        if (!desc) return '';
        if (typeof desc === 'object') {
            try {
                function extractText(node) {
                    if (!node) return '';
                    if (node.value) return node.value;
                    if (node.children) return node.children.map(extractText).join('');
                    return '';
                }
                return '<p>' + extractText(desc) + '</p>';
            } catch(e) { return String(desc); }
        }
        if (typeof desc === 'string' && (desc.includes('{"type"=>"root"') || desc.includes('{"type":"root"'))) {
            const match = desc.match(/"value"(?:=>|:)\s*"([^"]+)"/g);
            if (match) {
                const text = match.map(m => m.replace(/"value"(?:=>|:)\s*"/, '').slice(0, -1)).join(' ');
                return '<p>' + text + '</p>';
            }
        }
        return desc;
    }

    const formattedDesc = formatDescription(vDesc);

    // 1. Target directly below the variant selector buttons
    const underOptionsDesc = document.querySelector('#tt-variant-under-options-desc');
    if (underOptionsDesc) {
        if (!underOptionsDesc.dataset.originalDesc) {
            underOptionsDesc.dataset.originalDesc = underOptionsDesc.innerHTML;
        }
        if (formattedDesc && formattedDesc.trim() !== '') {
            underOptionsDesc.innerHTML = formattedDesc;
            underOptionsDesc.style.display = '';
        } else if (underOptionsDesc.dataset.originalDesc) {
            underOptionsDesc.innerHTML = underOptionsDesc.dataset.originalDesc;
        }
    }

    // 2. Target in bottom Details Tab
    const detailsTabDesc = document.querySelector('#tt-product-details-description, .tt-editorial-desc');
    if (detailsTabDesc) {
        if (!detailsTabDesc.dataset.originalDesc) {
            detailsTabDesc.dataset.originalDesc = detailsTabDesc.innerHTML;
        }
        if (formattedDesc && formattedDesc.trim() !== '') {
            detailsTabDesc.innerHTML = formattedDesc;
            detailsTabDesc.style.display = '';
        } else if (detailsTabDesc.dataset.originalDesc) {
            detailsTabDesc.innerHTML = detailsTabDesc.dataset.originalDesc;
        }
    }
}

function updateVariantDimensions(variantId) {
    if (!variantId) {
        const idInput = document.querySelector('input[name="id"], select[name="id"]');
        if (idInput) variantId = idInput.value;
    }
    if (!variantId) return;

    const vDimScript = document.querySelector('.tt-variant-dimensions');
    let vDim = null;
    if (vDimScript) {
        try {
            const vDimMap = JSON.parse(vDimScript.textContent);
            vDim = vDimMap[variantId];
        } catch(e) {
            console.error('Error parsing variant dimensions map:', e);
        }
    }

    function formatDimensions(dim) {
        if (!dim) return '';
        if (typeof dim === 'object') {
            try {
                function extractText(node) {
                    if (!node) return '';
                    if (node.value) return node.value;
                    if (node.children) return node.children.map(extractText).join('');
                    return '';
                }
                return extractText(dim);
            } catch(e) { return String(dim); }
        }
        if (typeof dim === 'string' && (dim.includes('{"type"=>"root"') || dim.includes('{"type":"root"'))) {
            const match = dim.match(/"value"(?:=>|:)\s*"([^"]+)"/g);
            if (match) {
                return match.map(m => m.replace(/"value"(?:=>|:)\s*"/, '').slice(0, -1)).join(' ');
            }
        }
        return String(dim).replace(/<[^>]+>/g, '').trim();
    }

    const formattedDim = formatDimensions(vDim);

    // 1. Target in DIMENSIONS tab (#tt-dimension-display-box)
    const dimBox = document.getElementById('tt-dimension-display-box');
    if (dimBox) {
        if (!dimBox.dataset.originalDim) {
            dimBox.dataset.originalDim = dimBox.innerHTML;
        }
        if (formattedDim && formattedDim.trim() !== '') {
            dimBox.innerHTML = '<strong>Dimensions :</strong> ' + formattedDim.trim().replace(/^dimensions?\s*:\s*/i, '');
        } else if (dimBox.dataset.originalDim) {
            dimBox.innerHTML = dimBox.dataset.originalDim;
        }
    }

    // 2. Target dimension line in description containers
    const descContainers = document.querySelectorAll('#tt-variant-under-options-desc, #tt-product-details-description, .tt-editorial-desc');
    descContainers.forEach(container => {
        const listItems = container.querySelectorAll('li, p');
        listItems.forEach(item => {
            if (/dimensions?\s*:/i.test(item.textContent)) {
                if (!item.dataset.originalItemText) {
                    item.dataset.originalItemText = item.innerHTML;
                }
                if (formattedDim && formattedDim.trim() !== '') {
                    const cleanVal = formattedDim.trim().replace(/^dimensions?\s*:\s*/i, '');
                    item.innerHTML = '<strong>Dimensions :</strong> ' + cleanVal;
                } else if (item.dataset.originalItemText) {
                    item.innerHTML = item.dataset.originalItemText;
                }
            }
        });
    });
}

function updateVariantDiscount(variantId) {
    if (!variantId) {
        const idInput = document.querySelector('input[name="id"], select[name="id"]');
        if (idInput) variantId = idInput.value;
    }
    if (!variantId) return;

    const vDiscScript = document.querySelector('.tt-variant-discounts');
    let discPercent = null;
    if (vDiscScript) {
        try {
            const vDiscMap = JSON.parse(vDiscScript.textContent);
            discPercent = vDiscMap[variantId];
        } catch(e) {
            console.error('Error parsing variant discounts map:', e);
        }
    }

    const saleBadges = document.querySelectorAll('.productView .badge.sale-badge, .productView .label_sale, .productView-moreItem .label_sale');
    if (discPercent && Number(discPercent) > 0) {
        const cleanVal = String(discPercent).replace('-', '').replace('%', '').trim();
        const formatted = '-' + cleanVal + '%';
        saleBadges.forEach(badge => {
            if (!badge.dataset.originalDiscount) {
                badge.dataset.originalDiscount = badge.innerHTML;
            }
            badge.innerHTML = formatted;
            badge.style.display = '';
        });
    } else {
        saleBadges.forEach(badge => {
            if (badge.dataset.originalDiscount) {
                badge.innerHTML = badge.dataset.originalDiscount;
            }
        });
    }
}

// Global click & change listener for variant selectors
document.addEventListener('click', function(e) {
    const targetEl = e.target.closest('label[data-variant-id], input[data-variant-id], .product-form__label, .variant-pill-btn, [data-header-option], .productView-options label, .product-form__input label');
    if (targetEl) {
        setTimeout(function() {
            const vId = getCurrentlySelectedVariantId();
            if (vId) {
                updateVariantGallery(vId);
                updateVariantDescription(vId);
                updateVariantDimensions(vId);
                updateVariantDiscount(vId);
            }
        }, 20);
    }
});

document.addEventListener('change', function(e) {
    const targetInput = e.target.closest('input[name="id"], select[name="id"], .product-form__radio, .product-option input, .product-option select');
    if (targetInput) {
        setTimeout(function() {
            const vId = getCurrentlySelectedVariantId();
            if (vId) {
                updateVariantGallery(vId);
                updateVariantDescription(vId);
                updateVariantDimensions(vId);
                updateVariantDiscount(vId);
            }
        }, 20);
    }
});

document.addEventListener('DOMContentLoaded', function() {
    const vId = getCurrentlySelectedVariantId();
    updateVariantGallery(vId);
    updateVariantDescription(vId);
    updateVariantDimensions(vId);
    updateVariantDiscount(vId);
});